import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI.js'
import PageTitleUI from '../../../widgets/output/PageTitleUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import CardUI from '../../../widgets/layout/CardUI'

const ComplianceListingPageUI = ({ context, compList, onRefreshClick }) =>
  <SuperUserSettingsPageUI context={context} className='pg_su_doc' topnav='settings'
    headerText='Compliance Listing' centered={!compList} page='complianceListing'  // Updated header and page
  >
    {
      (!compList) &&
      <SpinnerComponentUI />
    }
    {
      compList &&
      <div>
        <PageTitleUI context={context} titleText='Compliance List' />
        <div className='su_doc'>
          {compList.map(comp => (
            <CompListUI key={comp.complianceName} comp={comp} /> 
          ))}
        </div>
      </div>
    }
  </SuperUserSettingsPageUI>

const CompListUI = ({ comp }) => {
  const { complianceName } = comp
  return (
    <CardUI title={complianceName} className='g_m_bottom_100'>
      <span className='g_m_left_100 g_flex_v'>
        <table className='table'>
          <thead>
            <tr>
              <th>Clause</th>
              <th>Item</th>
              <th>Text</th>
            </tr>
          </thead>
          <tbody>
            {comp.clauseList && comp.clauseList.map((clause, index) => (
              <ClauseUI key={index} clause={clause} />
            ))}
          </tbody>
        </table>
      </span>
    </CardUI>
  )
}

const ClauseUI = ({ clause }) => {
  const itemList = clause.itemList
  return (
    <tr>
      <td>{clause.clauseName}</td>
      <td>{itemList.itemName}</td>
      <td>
        <div>
          <b>Non Compliance Text:</b>
          <p>{itemList.nonComplianceText}</p>
        </div>
        <div>
          <b>Remedial Action Text:</b>
          <p>{itemList.remedialActionText}</p>
        </div>
      </td>
    </tr>
  )
}

export default ComplianceListingPageUI
